import * as React from 'react';
import { ArticleHeading1, InlineText2 } from '@cian/ui-kit/typography';
import { IconMapCar16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';

import * as style from './SlideInfo.css';
import { ETransportType, IEcology } from '../../../../types/newbuilding/ecology';

interface ISlideInfoProps {
  ecology: IEcology | undefined;
}

export const SlideInfo: React.FC<ISlideInfoProps> = props => {
  const { ecology } = props;

  if (!ecology) {
    return null;
  }

  const Icon = ecology.transportType === ETransportType.Walk ? IconMapWalk16 : IconMapCar16;

  return (
    <div className={style['info']}>
      <ArticleHeading1 color={'text-inverted-default'} fontWeight={'bold'}>
        {ecology.title}
      </ArticleHeading1>
      {ecology.title && ecology.transportType && (
        <div className={style['distance']}>
          <InlineText2 color={'text-inverted-default'}>Расстояние от комплекса:</InlineText2>
          <div className={style['icon']}>
            <Icon color={'icon-inverted-default'} />
          </div>
          <InlineText2 color={'text-inverted-default'}>{ecology.distance}</InlineText2>
        </div>
      )}
    </div>
  );
};
